// extracted by mini-css-extract-plugin
export default {"NameField":"NameField_NameField","label":"NameField_label"};